<main>
  <app-impersonation *ngIf="impersonate"></app-impersonation>
  <app-header></app-header>
  <content>
    <div class="header-container">
      <h1>Pension Calculator Tool</h1>
    </div>
    <br /><br />
    <router-outlet></router-outlet>
  </content>
</main>
<app-footer></app-footer>
